import { apiClient } from '@/lib/apiClient';
import type {
  OrdemCompraResumo,
  OrdemCompraDetalhe,
  CriarOrdemCompraRequest,
  AtualizarOrdemCompraRequest,
  AprovarOrdemCompraRequest,
  RecebimentoCompraResumo,
  RecebimentoCompraDetalhe,
  ProcessarRecebimentoRequest,
  StatusOrdemCompra,
  FiltrosListaCompras,
  PaginadoComResumo,
} from '../types';
import { paramsListaCompras } from '../types';

const BASE = '/api/compras/ordens';

/** Filtros da consulta de POs: os comuns das listas (busca nº/fornecedor, período de emissão, ordenação) + os da paridade. */
export interface FiltrosOrdemCompra extends FiltrosListaCompras {
  fornecedorId?: number;
  numero?: number;
  /** Exclui canceladas e totalmente recebidas. */
  apenasAbertas?: boolean;
}

export const ordemCompraService = {
  /** Lista paginada; status, busca (número/fornecedor), período de emissão, fornecedor e ordenação são feitos no servidor. */
  async getAll(
    pagina = 1, tamanhoPagina = 20, status?: StatusOrdemCompra, filtros: FiltrosOrdemCompra = {},
  ): Promise<PaginadoComResumo<OrdemCompraResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<OrdemCompraResumo>>(BASE, {
      params: {
        pagina, tamanhoPagina, status, ...paramsListaCompras(filtros),
        fornecedorId: filtros.fornecedorId || undefined,
        numero: filtros.numero || undefined,
        apenasAbertas: filtros.apenasAbertas || undefined,
      },
    });
    return data;
  },

  async getById(id: number): Promise<OrdemCompraDetalhe> {
    const { data } = await apiClient.get<OrdemCompraDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarOrdemCompraRequest): Promise<OrdemCompraDetalhe> {
    const { data } = await apiClient.post<OrdemCompraDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarOrdemCompraRequest): Promise<OrdemCompraDetalhe> {
    const { data } = await apiClient.put<OrdemCompraDetalhe>(`${BASE}/${id}`, request);
    return data;
  },

  async enviar(id: number): Promise<OrdemCompraResumo> {
    const { data } = await apiClient.post<OrdemCompraResumo>(`${BASE}/${id}/enviar`);
    return data;
  },

  async aprovar(id: number, request: AprovarOrdemCompraRequest): Promise<OrdemCompraResumo> {
    const { data } = await apiClient.post<OrdemCompraResumo>(`${BASE}/${id}/aprovar`, request);
    return data;
  },

  async enviarParaFornecedor(id: number): Promise<OrdemCompraResumo> {
    const { data } = await apiClient.post<OrdemCompraResumo>(`${BASE}/${id}/enviar-fornecedor`);
    return data;
  },

  async getRecebimentos(id: number): Promise<RecebimentoCompraResumo[]> {
    const { data } = await apiClient.get<RecebimentoCompraResumo[]>(`${BASE}/${id}/recebimentos`);
    return data;
  },

  async processarRecebimento(id: number, request: ProcessarRecebimentoRequest): Promise<RecebimentoCompraDetalhe> {
    const { data } = await apiClient.post<RecebimentoCompraDetalhe>(`${BASE}/${id}/receber`, request);
    return data;
  },

  async cancelar(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
